import React, { useEffect, useState } from 'react';
import './PageTransition.css';

const PageTransition = ({ children }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Small delay so the fade-in feels intentional
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`page-transition ${visible ? 'visible' : ''}`}>
      {children}
    </div>
  );
};

export default PageTransition;